<template lang="pug">
  v-app
    admin-drawer
    v-main
      v-container(fluid)
        nuxt
    dialogs
    notification
    snackbars
</template>

<script>
import dialogs from '~/layouts/includes/dialogs'
import notification from '~/layouts/includes/notification'
import AdminDrawer from '~/layouts/includes/admin-drawer'
import snackbars from '~/layouts/includes/snackbars'

export default {
  name: 'Admin',
  components: {
    dialogs,
    notification,
    AdminDrawer,
    snackbars
  }
}
</script>

<style scoped lang="scss"></style>
